<div class="travel-settings-container" [formGroup]="travelSettingsForm">
    <div class="row row-height">
        <label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_TITLE' | translate}}</label>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_PER_DIEM_RATE' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="diemRate" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_MILEAGE_RATE' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="mileageRate" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_LODGING_RATE' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="lodgingRate" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_PARKING_RATE' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="parkingRate" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_TOLLS_RATE' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="tollsRate" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
            <div class="row row-height">
                <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_TRAVEL_SETTINGS_MILEAGE_RT' | translate}}</label></div>
                <div class="col-sm-4">
                    <mat-form-field class="full-width col-sm-12" appearance="outline">
                        <input matInput type="text" mask="separator.2"  formControlName="mileageRT" [leadZero]="true">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>